import React,{useEffect,useState} from 'react'
import { useNavigate } from 'react-router-dom';
import "../Styles/Past_tour.css"
import Rajasthan from "../Images/rajasthan_pic.png"
import api from '../Api.js';
import { showToast } from './PopupMessage.jsx';
import dayjs from 'dayjs';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

function Past_tour() {
  const navigate = useNavigate();
const [openPopupUnique, setOpenPopupUnique] = React.useState(false);
const [hotelId, setHotelId] = useState(null);
const [rating, setRating] = useState(0);
const [comment, setComment] = useState('');
const openPopupUniqueBotton = (hId) => {
  setOpenPopupUnique(true);
  setHotelId(hId);
}
const closePopupUniquebotton = ()=>{
  setOpenPopupUnique(false);
  document.getElementById("popupUnique").style.display="none";
}
const [bookedHotels, setBookedHotels] = React.useState([]);
const customer = JSON.parse(localStorage.getItem('customer')) || {};
const token = localStorage.getItem('accessToken') || '';
console.log('Customer from localStorage:', customer);

useEffect(() => {
const fetchBookedHotels = async () => {
  try {
    // Replace with your API endpoint
    const response = await api.get(`/bookings/user/${customer?.id}`, {
      
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Include the token in the Authorization header
      }
    });

    console.log('Booked Hotels:', response.data);
    if(response.data.status === true){
      setBookedHotels(response.data?.data || []);
      showToast('Fetched booked hotels successfully!', 'success');
    }
  } catch (error) {
    console.error('Error fetching booked hotels:', error);
  }  
}

fetchBookedHotels();

},[])

const bookedhotel = bookedHotels.filter(booking => booking.status === 'confirmed');
console.log('Confirmed Booked Hotels:', bookedhotel);

 const [page, setPage] = useState(1);

 const itemsPerPage = 3;
  const totalPages = Math.ceil(bookedhotel.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = bookedhotel.slice(startIndex, endIndex);

 const [existingReview, setExistingReview] = useState(null);

// Fetch reviews when popup opens
useEffect(() => {
  const GetReviews = async () => {
    try {
      const response = await api.get(`/reviews`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      if (response.data.status) {
        const found = response.data.data.find(
          (review) =>
            review.user_id === customer.id && review.hotel_id === hotelId
        );
        if (found) {
          setExistingReview(found);
          setRating(found.rating);
          setComment(found.comment);
        } else {
          setExistingReview(null);
          setRating(0);
          setComment("");
        }
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  if (hotelId) {
    GetReviews();
  }
}, [hotelId, customer.id, token]);

// Submit or Update Review
const handleReview = async (e) => {
  e.preventDefault();

  if (!rating) {
    showToast("Please select a rating.", "error");
    return;
  }
  if (!comment) {
    showToast("Please enter your review.", "error");
    return;
  }

  try {
    const payload = { hotel_id: hotelId, rating, comment };

    let response;
    if (existingReview) {
      // Update existing review
      response = await api.put(`/reviews/${existingReview.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } else {
      // Create new review
      response = await api.post("/reviews", payload, {
        headers: { Authorization: `Bearer ${token}`}
      });
    }

    if (response.data.status) {
      showToast(
        existingReview
          ? "Review updated successfully!"
          : "Review submitted successfully!",
        "success"
      );
      closePopupUniquebotton();
    } else {
      showToast("Failed to save review.", "error");
    }
  } catch (error) {
    console.error("Error saving review:", error);
    showToast("An error occurred while saving your review.", "error");
  }
};





  return (
    <div>

{openPopupUnique && (
  <div className="popup-overlay-unique" id="popupUnique">
    <div className="popup-box-unique">
      <form className="popup-form-unique" onSubmit={handleReview}>
        <h2 className="popup-title-unique">⭐ Review Your Tour</h2>

        {/* Rating stars */}
        <div className="rating-unique">
          {[5, 4, 3, 2, 1].map((star) => (
            <React.Fragment key={star}>
              <input
                type="radio"
                id={`star${star}`}
                name="rating"
                value={star}
                checked={Number(rating) === star}
                onChange={(e) => setRating(Number(e.target.value))}
              />
              <label htmlFor={`star${star}`} title={`${star} stars`}>
                ★
              </label>
            </React.Fragment>
          ))}
        </div>

        {/* Comment */}
        <textarea
          className="review-text-unique"
          placeholder="Write your review here..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />

        <button type="submit" className="popup-submit-btn-unique">
          {existingReview ? "Update Review" : "Submit Review"}
        </button>
        <button
          type="button"
          className="popup-close-btn-unique"
          onClick={closePopupUniquebotton}
        >
          Close
        </button>
      </form>
    </div>
  </div>
)}


{
  bookedhotel.length === 0 ? 
      <p>No confirmed hotel bookings found.</p>
      :
      <>
      {
        currentItems.map((booking) => (
                            <div class="tripCard_wrapper">
        <div class="tripCard_image">
          <img src={`https://admin.jayrajgroup.org/uploads/hotels/${booking?.room?.hotel?.featured_image}`} alt="Rajasthan Tour" />
        </div>
        <div class="tripCard_content">
          <h2 class="tripCard_title">{booking?.room?.hotel?.name}</h2>
          <p class="tripCard_date" style={{margin:"0px",fontWeight:"500"}}>{booking?.room?.hotel?.location}</p>
          <p class="tripCard_date" style={{margin:"0px",fontWeight:"500"}}>{booking?.room?.name}</p>
          <p class="tripCard_date" style={{margin:"0px",fontWeight:"700"}}>Total: ₹{booking?.total_price}/-</p>
          <p class="tripCard_date" style={{fontWeight:"700"}}>{dayjs(booking?.check_in).format("YYYY-MM-DD HH:mm:ss A")
} - {dayjs(booking?.check_out).format("YYYY-MM-DD HH:mm:ss A")
}</p>
          <div class="tripCard_buttons">
            <button class="tripCard_btnCancel" style={{backgroundColor:"#AF7A2C"}} onClick={()=>navigate(`/hotel/${booking?.hotel_id}`)}>Details</button>
            <button class="tripCard_btnDetails" onClick={()=>openPopupUniqueBotton(booking?.hotel_id)}>Review</button>          
            <button class="tripCard_btnCancel">Cancel</button>
          </div>
        </div>
      </div>
        ))
      }
      {currentItems.length > 0 && (
        <div className="tourPaginationBar">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
          </Stack>
        </div>
      )}

      </>


}



    </div>
  )
}

export default Past_tour